import 'moment/locale/fr';
import moment from 'moment';

moment.locale('fr');
